import { combineReducers } from 'redux';
import {
  HANDLED_CHANGE,
  HANDLED_VALIDATED_FIELD,
  HANDLED_VALIDATED_FIELDS,
  SET_MESSAGE,
  FETCHED_CONTRACT,
  SAVED_CONTRACT,
  LAUNCHED_CONTRACT_TOGGLE,
  SENT_TOKENS,
  RESET_FORM,
} from './actionTypes';
import erc20FieldDefinitions from './erc20FieldDefinitions';

function convertFieldDefinitionsToDefaultUserInput(fieldDefinitions) {
  const defaultValues = {};
  const keys = Object.keys(fieldDefinitions);
  for (let i = 0; i < keys.length; i += 1) {
    const key = keys[i];
    const fieldDefinition = fieldDefinitions[key];
    const { defaultValue, ComponentName } = fieldDefinition;
    // Don't initialize values for HTML components.
    if (ComponentName !== 'HTML') {
      // Set a specific default value, if provided, fallback to empty string.
      defaultValues[key] = defaultValue !== undefined ? defaultValue : '';
    }
  }
  return defaultValues;
}

export const contractFormReducer = (
  state = {
    fieldDefinitionsSerializable: erc20FieldDefinitions,
    uiState: { message: '' },
  },
  action,
) => {
  if (state.userInput === undefined) {
    // This is sort of gross, because we end up ignoring the action, HOWEVER
    // this will only occur on the initialization of the Redux store, as in all
    // other cases the `userInput` will be at least an object.
    return {
      ...state,
      userInput: convertFieldDefinitionsToDefaultUserInput(state.fieldDefinitionsSerializable),
      validationErrors: {},
    };
  }

  const { id, value } = action;
  switch (action.type) {
    case HANDLED_CHANGE: {
      const userInput = { ...state.userInput, [id]: value };
      return { ...state, userInput };
    }
    case HANDLED_VALIDATED_FIELD: {
      const validationErrors = { ...state.validationErrors, [id]: value };
      return { ...state, validationErrors };
    }
    case HANDLED_VALIDATED_FIELDS: {
      const validationErrors = value;
      return { ...state, validationErrors };
    }
    case SET_MESSAGE:
      return { ...state, uiState: { message: action.value } };
    case RESET_FORM: {
      // Keep the following line under max length.
      const { fieldDefinitionsSerializable } = state;
      const userInput = convertFieldDefinitionsToDefaultUserInput(fieldDefinitionsSerializable);
      return { ...state, userInput };
    }
    default:
      return state;
  }
};

export const contractReducer = (state = { data: '' }, action) => {
  switch (action.type) {
    case FETCHED_CONTRACT:
      return { data: action.data };
    default:
      return state;
  }
};

export const contractsReducer = (state = { contracts: [], contractToggles: {} }, action) => {
  switch (action.type) {
    case SAVED_CONTRACT: {
      // Copy it, so we don't update the original.
      const contractValues = Object.assign({}, action.userInput);
      // Fake id field for now.
      contractValues.id = state.contracts.length;
      // Initialize token balance from initial supply - no type for now, bad for display.
      contractValues.balance = contractValues.initialSupply;
      const updatedContracts = [...state.contracts, contractValues];
      return { ...state, contracts: updatedContracts };
    }
    case SENT_TOKENS: {
      const { id, tokens } = action;
      const updatedContracts = state.contracts;
      updatedContracts[id].balance -= tokens;
      return { ...state, contracts: updatedContracts };
    }
    case LAUNCHED_CONTRACT_TOGGLE: {
      const updatedContractToggles = { ...state.contractToggles };
      updatedContractToggles[action.tokenName] = !updatedContractToggles[action.tokenName];
      return { ...state, contractToggles: updatedContractToggles };
    }
    default:
      return state;
  }
};

export default combineReducers({
  contractForm: contractFormReducer,
  contract: contractReducer,
  contracts: contractsReducer,
});



// WEBPACK FOOTER //
// ./src/reducers.js